export default {
  en: {
    English: 'English',
    Dutch: 'Nederlands',
    German: 'Deutsch',
    All: "(All)",
    None: "(None)",
    Unknown: "Unknown",
    Manage: "Manage",
    Admin: "Admin",
    Authentication: 'Authentication',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    IsDeleted: "Deleted?",
    Success: "Success",
    RecordAdded: "Record is added",
    RecordUpdated: "Record is updated",
    RecordDeleted: "Record is deleted",
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    User: 'User',
    New: "New",
    View: 'View',
    Edit: 'Edit',
    Delete: "Delete",
    ConfirmDelete: "Confirm Delete",
    ByOrganisation: "By Organisation",
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    Charts: 'Charts',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: 'Export Selected',
    Other: 'Others',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Support',
    UpdatedMessage: 'The selected {entity} was successfully updated',
    AboutToDeleteMessage: 'You are about delete {entity} {name}',
    DeletedMessage: '{entity} {name} is deleted',
    DeletedTitle: '{entity} deleted',
    Ok: "Ok",
    Cancel: "Cancel",
    Save: "Save",
    Reset: "Reset",
    Id: "Id",
    Name: "Name",
    Preferences: "Preferences",
    ChangeImage: "Change Image",
    Language: {
      English: "English",
      Dutch: "Dutch",
      German: "German",
      French: "French",
      Spanish: "Spanish"
    },
    Country: {
      gb: "United Kingdom",
      nl: "The Netherlands",
      de: "Germany",
      us: "United States of America",
      be: "Belgium",
      fr: "France"
    },
    Topic: {
      WORLD: "World",
      NATION: "Country",
      BUSINESS: "Business",
      TECHNOLOGY: "Technology",
      ENTERTAINMENT: "Entertainment",
      SCIENCE: "Science",
      SPORTS: "Sports",
      HEALTH: "Health",
    },
    Products: {
      DailyBudget: "Daily Budget",
      Banners: "Create Banners",
      Discount: "Discount",
      Setup: "Setup",
      Other: "Other"
    },
    Weekdays: {
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday"
    },
    Dashboard: {
      Title: "Dashboard",
      Analytics: 'Analytics',
      AnalyticsData: "Analytics Data",
      NoActiveCampaign: "There is no active campaign yet. When your first campaign has started, you will see the statistics here."
    },
    Analytics: {
      ImpressionsComparison: "Impressions Comparison",
      Performance: "Performance",
      Clicks: "Clicks",
      Conversions: "Conversions",
      Impressions: "Impressions",
      AmountSpent: "Amount Spent",
      CostsPerClick: "Costs per click",
      ThisMonth: "This Month",
      LastMonth: "Last Month"
    },
    Banner: {
      Title: "Banners"
    },
    Campaign: {
      Title: "Campaign",
      Name: "Name",
      NameRequired: "Name is required",
      NewsFeeds: "Newsfeeds used for this campaign",
      List: "Campaigns",
      View: "Campaign Details",
      Edit: "Edit Campaign",
      NewCampaign: "New Campaign",
      Strategies2: "Retailers",
      Strategies3: "Jobs",
      Strategies4: "Products",
      Strategies5: "Articles",
      Images: "Images",
      IdStrategyType: "Campaign Type",
      StrategyType: "Campaign Type",
      StrategyTypeRequired: "Campaign Type is required",
      JobFeed: "Jobfeed",
      ArticleList: "Article List",
      IsPremium: "Is Premium?",
      IsPremiumDetail: "Is this a premium campaigns?",
      IsActive: "Is Active?",
      IsActiveDetail: "Is this campaign active?",
      HasStrategies: "Has strategies?",
      HasStrategiesDetail: "Does this campaign have strategies?",
      Subscriptions: "Subscriptions",
      HasSubscriptions: "Has subscriptions?",
      HasSubscriptionsDetail: "Does this campaign have subscriptions?",
      CampaignId: "CampaignId",
      Updated: "The selected campaign was successfully updated",
      RetailerCanBuySubscription: "Can the retailer buy a subscription?",
      AdvertiserCanAddSubscription: "Can the advertiser add a subscription (on account)",
      StartDate: "Start Date",
      EndDate: "End Date",
      Budget: "Budget",
      AmountSpent: "- Amount Spent",
      AmountPlanned: "- Amount Planned",
      AmountPlannable: "- Amount to be planned",
      BudgetLines: "Budget Lines",
      LinkOrderLines: "Link Order Lines",
      AddOrderLines: "Link",
      DeleteBudgetLineQuestion: "Do you want to delete thus budget line",
      PlanningPerDay: "Planning",
      SpentPerDay: "Spent",
      AddBudgetDays: "Add Daily Budgets",
      BudgetPerDay: "Daily Budgets"
    },
    CampaignDailyBudget: {
      BudgetDate: "Budget Date",
      Budget: "Budget",
      Spent: "Spent",
      NumberOfDays: "Number of days",
      StartDate: "Start Date",
      NumberOfDaysRequired: "Number of day is required",
      NumberOfDaysRange: "Number of Days must be between 1 and 1000",
      StartDateRequired: "Start Date is required",
      BudgetRequired: "Budget is required",
      BudgetRange: "Must be between 10 en 100.000",
      Weekdays: "Choose the days of the week",
      Description: "Description",
      Totals: "Totals",
      AddBudgetDaysButton: "Add Daily Budgets",
      AmountPlannable: "Amount available",
      BudgetToAdd: "Total Budget to add",
      BudgetRemainder: "Remaning Budget",
      BudgetDeficit: "Budget Deficit",
      BudgetBalanceNegative: "Cannot add these daily budgets because there is a budget deficit",
      BudgetAdded: "Daily budgets are added",
      WeekdayRequired: "Please select at least 1 weekday",
      Difference: "Balance",
      DayOfWeek: "Day"
    },
    CampaignImage: {
      List: "Images",
      Type: "Image Type",
      Categories: "Use for categories",
      ImageUploadRequired: "Please upload an image first",
      SubmitAdd: "Save",
      Added: "The image is added to the campaign",
      UploadImageText1: "Drag & drop the imagefile here",
      UploadImageText2: "…or click here.",
      Image: "Image",
      AddImage: "Add Image",
      Delete: "Delete image",
      DeleteQuestion: "Do you want to delete this image?",
      Deleted: "The image is deleted",
    },
    JobFeed: {
      Title: "Jobfeed",
      Name: "Name",
      NameRequired: "Name is required",
      List: "Jobfeeds",
      View: "Jobfeed Details",
      Edit: "Edit Jobfeed",
      New: "New Jobfeed",
      IdJobFeedType: "Feed Type",
      JobFeedTypeRequired: "Jobfeed Type is required",
      Jobs: "Jobs",
      FeedUrl: "Feed Url",
      FeedUrlRequired: "Feed Url is required",
      Added: "The jobfeed is added",
      Updated: "The jobfeed is updated",
      Deleted: "The jobfeed is deleted",
      DeleteQuestion: "Do you want to delete jobfeed \"{name}\" ?"
    },
    JobItem: {
      ReferenceNumber: "Reference",
      Title: "Title",
      Date: "Date",
      Url: "Url",
      Categories: "Categories"
    },
    Login: {
      Title: "Login to UpStreamAds",
      Login: 'Login',
      LoginFailed: "Email or password are incorrect",
      Welcome: "Welcome back, please login to your UpStreamAds account.",
      Register: 'Register',
      ForgotPassword: 'Forgot password?',
      Email: "Email",
      EmailPlaceholder: "Email",
      Password: "Password",
      PasswordPlaceholder: "Password",
      AlreadyLoggedIn: "You are alread logged in"
    },
    ForgotPassword: {
      BackToLogin: "Back to login",
      RecoverYourPasswordTitle: "Recover your password",
      CheckYourEmailTitle: "Check your email",
      PleaseEnterEmail: "Please enter your email address and we'll send you instructions on how to reset your password.",
      PleaseCheckInbox: "Please check your email. We have sent you an email with a temporary code. Please enter the code below",
      RecoverPassword: "Recover Password"
    },
    ArticleList: {
      Title: "Article List",
      Name: "Name",
      Reference: "Reference",
      List: "Article Lists",
      View: "Article List Details",
      Edit: "Edit Campaign",
      New: "New Article List",
      Articles: "Articles",
      Created: "The articlelist has been created",
      DeleteQuestion: "Do you want to delete article list \"{name}\"?",
      ActiveArticles: "Active Articles",
      InactiveArticles: "Inactive articles",
      Added: "The article list is added",
      Updated: "The article list is updated",
      Deleted: "The article list is deleted",
      Settings: "Settings",
      Fields: "Fields",
      FeedUrl: "RssFeed Url",
      SyncFeed: "Sync with RssFeed",
      SyncQuestion: "Do you want to synchronize the article list \"{name}\" with the RssFeed?",
      Synchronize: "Synschronize",
      Synchronized: "The article list is synchronized",
      ConfirmSync: "Synchronize?"
    },
    Article: {
      New: "New article",
      Edit: "Edit",
      Deactivate: "Deactivate",
      DeactivateQuestion: "Do you want to deactivate the article \"{title}\"? It will be effective immediately",
      Deactivated: "Article \"{title}\" is deactivated",
      Activate: "Activate",
      ActivateQuestion: "Do you want to activate the article \"{title}\"? It will be effective immediately",
      Activated: "Article \"{title}\" is activated",
      TitleNew: "New article",
      TitleEdit: "Edit article",
      Title: "Title",
      TitleRequired: "Title is required",
      Summary: "Summary",
      Kind: "Kind",
      CallToAction: "Call to action",
      Url: "Url",
      UrlRequired: "Url is required",
      UploadImageText1: "Drag & drop the imagefile here",
      UploadImageText2: "…or click here.",
      Image: "Image",
      ImageUploadRequired: "Please upload an image first",
      Added: "The article is added",
      Updated: "The article is updated",
      Deleted: "The article is deleted"
    },
    Field: {
      New: "New field",
      Edit: "Edit field",
      Name: "Name",
      NameRequired: "Name is required",
      FieldType: "Field Type",
      Label: "Label",
      LabelRequired: "Label is required",
      Updated: "The field is updated",
      Added: "The is is added",
      Deleted: "The field is deleted",
      DeleteQuestion: "Do you want to delete field \"{name}\" ?"
    },
    FieldTypes: {
      Text: "Text",
      Html: "Html",
      Boolean: "Yes/No",
      Number: "Number",
      DateTime: "DateTime",
      Image: "Image",
      ImageList: "ImageList"
    },
    NewsArticleList: {
      Title: "Newsfeed",
      Name: "Name",
      NameRequired: "Name is required",
      Reference: "Reference",
      List: "Newsfeeds",
      View: "Newsfeed Details",
      Edit: "Edit Newsfeed",
      New: "New Newsfeed",
      Preview: "Preview",
      Created: "The newsfeed is added",
      Updated: "The newsfeed is updated",
      DeleteQuestion: "Do you want to delete newsfeed \"{name}\"?",
      DeletedTitle: "Newsfeeds is deleted",
      DeletedMessage: "The selected newsfeed is deleted",
      Settings: "Settings",
      Keywords: "Keywords",
      Kind: "Kind",
      KindRequired: "Kind is required",
      Country: "Country",
      CountryRequired: "Country is required",
      Language: "Language",
      LanguageRequired: "Language is required",
      Topic: "Topic",
      TpoicRequired: "Topic is required"
    },
    Keyword: {
      List: "Keywords",
      New: "New Keyword",
      Edit: "Edit Keyword",
      Value: "Keyword",
      ValueRequired: "Keyword is required",
      Kind: "Kind",
      ExactMatch: "Exact Match?",
      Deleted: "The field is deleted",
      DeleteQuestion: "Do you want to delete field \"{name}\" ?"
    },
    NewsfeedKind: {
      Headlines: "Headlines",
      HeadlinesByTopic: "Headlines by topic",
      HeadlinesByLocation: "Headlines by location",
      Keywords: "Keywords"
    },
    KeywordKind: {
      Include: "Including",
      Exclude: "Excluding"
    },
    Organisation: {
      Title: "Organisation",
      Name: "Name",
      LogoUrl: "Logo Url",
      List: "Organisations",
      View: "Organisation Details",
      Edit: "Edit Organisation",
      Users: "Organisation Users",
      AddUsers: "Add Users",
      InviteUser: "Invite User",
      Choose: "Choose organisation",
      ButtonChoose: "Choose",
      New: "New Organisation",
      Added: "The organisation is added",
      Updated: "The organisation is updated",
      Deleted: "The organisation is deleted",
      DeleteQuestion: "Do you want to delete organisation \"{name}\" ?",
      TradeName: "Trade Name",
      Street: "Street",
      HouseNumber: "House Number",
      HouseNumberAddition: "House Number Addition",
      City: "City",
      PostalCode: "Postal Code",
      Country: "Country",
      StreetRequired: "Street is required",
      HouseNumberRequired: "House Number is required",
      HouseNumberInvalid: "House Number must be between 1 and 999999",
      CityRequired: "City is required",
      PostalCodeRequired: "Postal Code is required",
      CountryRequired: "Country is required",
      VatNumber: "VAT Number",
      VatExemption: "VAT Exemption applicable?"
    },
    Advertiser: {
      Title: "Advertiser",
      Name: "Name",
      OrganisationName: "Organisation",
      AdvertiserId: "AdvertiserId",
      AdvertiserIdDetail: "AdvertiserId (at the provider)",
      List: "Advertisers",
      View: "Advertiser Details",
      Edit: "Edit Advertiser",
      Agency: "Agency",
      IsPremium: "IsPremium",
      IsPremiumDetail: "Is premium advertiser?",
      AgencyName: "Agency",
      ProviderName: "Provider",
      OwnerName: "Owner",
      OwnerEmail: "Email Owner",
      NameRequired: "Name is required",
      OrganisationRequired: "Organisation is required",
      AgencyRequired: "Agency is required",
      OwnerRequired: "Owner is required",
      ProviderAdvertiserRequired: "AdvertiserId (at the provider) is required",
      Campaigns: "Campaigns",
      New: "New advertiser",
      AddCampaigns: "Add Campaigns",
      Added: "The advertiser is added",
      Updated: "The advertiser is updated",
      DeleteQuestion: "Do you want to delete advertiser \"{name}\" ?",
      Deleted: "The advertiser is deleted"
    },
    OrganisationUser: {
      List: "Users",
      Title: "User",
      Name: "Name",
      Email: "Email",
      Role: "Role",
      Language: "Language",
      Company: "Company",
      FirstName: "First Name",
      LastName: "Last Name",
      PhoneNumber: "Phone Number",
      SendInvitation: "Send invitation",
      ExcelReport: "Daily Excel Report?",
      ReportingPeriod: "PDF Report",
      ReportingDays: "PDF Reporting Days",
      AddUsersToOrganisation: "Add users to organisation",
      AddUsers: "Add Users",
      EmailRequired: "Email is required",
      EmailInvalid: "Email is invalid",
      EmailAlreadyRegistered: "As user with this email already exists",
      FirstNameRequired: "First Name is required",
      LastNameRequired: "Last Name is required",
      EntityAlreadyExistsException: "A user with this email is already linked to this organisation",
      IsMainContact: "Main contact?",
      IsFinancialContact: "Financial contact?"
    },
    Profile: {
      Title: "Profile",
      General: "General",
      ChangePassword: "Change Password",
      Preferences: "Preferences",
      NewPassword: "New password",
      RepeatPassword: "Repeat password",
      PasswordRequired: "Please enter your new password",
      PasswordMinLength: "Password should be at least 5 characters (preferably more)",
      PasswordsMustMatch: "Passwords should match",
      PasswordChanged: "Your password is changed",
      Company: "Company",
      DisplayName: "Display Name",
      ProfileUpdated: "Your data has been updated",
      FirstName: "First Name",
      FirstNameRequired: "First Name is required",
      LastName: "Last Name",
      LastNameRequired: "Last Name is required",
      Street: "Street",
      HouseNumber: "House Number",
      HouseNumberAddition: "House Number Addition",
      City: "City",
      PostalCode: "Postal Code",
      Country: "Country",
      Language: "Language",
      StreetRequired: "Street is required",
      HouseNumberRequired: "House Number must be between 1 and 999999",
      CityRequired: "City is required",
      PostalCodeRequired: "Postal Code is required",
      CountryRequired: "Country is required",
      LanguageRequired: "Language is required",
      VatNumber: "VAT Number",
      VatExemption: "VAT Exemption applicable?"
    },
    Retailer: {
      Name: "Name",
      Address1: "Address1",
      Address2: "Address2",
      Title: "Retailer",
      List: "Retailers",
      Users: "The following users can access the data of this retailer:"
    },
    RetailerUser: {
      List: "Users",
      Title: "User",
      Edit: "Edit Retailer User",
      Name: "Name",
      Email: "Email",
      Role: "Role",
      IsOwner: "Is Owner?",
      Language: "Language",
      Company: "Company",
      FirstName: "First Name",
      LastName: "Last Name",
      PhoneNumber: "Phone Number",
      InviteUser: "Invite User",
      SendInvitation: "Send invitation",
      AddUsersToRetailer: "Add users to retailer",
      AddUsers: "Add Users",
      EmailRequired: "Email is required",
      EmailInvalid: "Email is invalid",
      EmailAlreadyRegistered: "As user with this email already exists",
      FirstNameRequired: "First Name is required",
      LastNameRequired: "Last Name is required",
      EntityAlreadyExistsException: "A user with this email is already linked to this organisation"
    },
    Subscription: {
      Description: "Description",
      NoSubscriptionsActive: "There is no active subscription (yet)",
      DailyBudgetFor: "Daily Budget for",
      Create: "Create Subscription",
      Buy: "Buy Subscription",
      StartDate: "Start date",
      DailyBudget: "Daily Budget",
      TotalDays: "Total Days",
      DaysSpent: "Days Spent",
      DaysPaused: "Days paused",
      SubscriptionId: "ID",
      Actions: "Actions",
      ActionPause: "Pause subscription",
      ActionResume: "Resume subscription",
      ActionStop: "Stop subscription",
      Details: "Details",
      State: "State",
      Created: "Order date",
      EndDate: "End Date",
      NoSubscriptionsHeading: "No subscriptions yet",
      NoSubscriptionsText: "There are no subscriptions for your campaign",
      NoSubscriptionsInfo: "To add a subscription, you can add credit to your campaign",
      BuySubscription: "Add Credit",
      Progress: "Progress",
      TotalBudget: "Total Budget",
      RemainingBudget: "Budget Remaining",
      ActionPauseQuestion: "Do you want to pause this subcription? The subscription will be paused starting tomorrow.",
      ActionResumeQuestion: "Do you want to resume this subcription? The subscription will be resumed starting tomorrow.",
      ActionStopQuestion: "Do you want to stop this subcription? Tomorrow, the subscription will be stopped.",
      PauseRequested: "Subscription Pause is requested",
      ResumeRequested: "Subscription Resume is requested",
      StopRequested: "Subscription Stop is requested"
    },
    BuySubscription: {
      Title: "Buy Subscription",
      SelectDateRange: "Start- and enddate",
      DailyBudget: "Daily budget",
      RunTime: "Run Time (days)",
      TotalBudget: "Total Budget",
      TotalBudgetExplanation: "{days} days x {euro} per day",
      TotalVat: "V.A.T. 21%",
      PaymentTotal: "Total Amount",
      Days: "Days",
      Buy: "Buy",
      OrderHasBeenPlacedAndPaid: "Your order has been placed and paid",
      MinBudgetWarning: "Warning: a daily budget lower than 3 euro is less effective!",
      OrderAndPay: "Order and Pay",
      ExchangeVoucher: "Exchange Voucher Code",
      VoucherCode: "Voucher Code",
      ApplyVoucher: "Apply",
      VoucherAlreadyUsed: "Voucher is already used",
      VoucherExpired: "This voucher is expired",
      VoucherNotFound: "No voucher found with this code",
      VoucherNotYetValid: "Voucher is not yet valid",
      RemoveVoucherCode: "Remove vouchercode {code}",
      ReductionAmount: "Korting",
      ReductionExplanation1: "Max \u20ac {voucherValue} reduction",
      ReductionExplanation2: "\u20ac {voucherValue} reduction if you spend \u20ac {voucherMinimumSpentAmount} or more"
    },
    Order: {
      List: "Orders",
      View: "Order Details",
      Edit: "Edit Order",
      New: "New Order",
      Order: "Order",
      OrderNumber: "Order Number",
      OrderDate: "Order Date",
      ProposalDate: "Proposal Date",
      ProposalValidUntil: "Proposal valid until",
      OrderLines: "Order Lines",
      General: "General",
      Notes: "Notes",
      TotalBudgetExplanation: "{days} days x {euro} per day",
      LineExplanation: "{quantity} x {pricePerUnit}",
      StartDate: "Start Date",
      EndDate: "End Date",
      Details: "Details",
      Amount: "Amount",
      AmountVAT: "VAT",
      OrderTotal: "Order Total",
      DownloadInvoice: "Download Invoice",
      Description: "Description",
      DescriptionRequired: "Description is required",
      CustomerReference: "Purchase Order#",
      CreateInvoice: "Create Invoice",
      SendInvoice: "Email Invoice",
      State: "State",
      DeleteQuestion: "Do you want to delete order \"{name}\"?",
      Added: "The order is added",
      Updated: "The order is updated",
      Deleted: "The order is deleted",
      EmailProposal: "Email proposal",
      EmailOrder: "Email order",
      EmailSendButton: "Send",
      EmailUser: "Send the e-mail to",
      CreateInvoiceButton: "Create Invoice",
      InvoiceDate: "Invoice Date"
    },
    OrderLine: {
      IdProduct: "Product",
      IdProductRequired: "Product is verplicht",
      Description: "Description",
      DescriptionRequired: "Description is required",
      PricePerUnit: "Unit Price",
      Quantity: "Quantity",
      Total: "Total",
      New: "Add line",
      StartDate: "Start Date",
      EndDate: "End Date",
      QuantityRequired: "Quantity is required",
      QuantityRange: "Quantity must be between 1 and 1000",
      PricePerUnitRequired: "Unit Price is required",
      PricePerUnitRange: "Unit Price must be between -100.000 en 100.000"
    },
    OrderState: {
      Created: "Created",
      PaymentInProgress: "Payment in Progress",
      Confirmed: "Confirmed",
      PaymentCanceled: "Payment Canceled",
      Canceled: "Canceled",
      Proposal: "Proposal",
      Archived: "Archived"
    },
    PaymentFinished: {
      Title: "Payment Status",
      PaymentSuccessHeading: "Payment Success",
      PaymentSuccessText: "Thank you for your purchase!",
      PaymentSuccessFooter: "Your account has been credited with the paid amount.",
      PaymentPendingHeading: "Payment Pending",
      PaymentPendingText: "The payment is pending and will be added to your account as soon as it completes.",
      PaymentPendingFooter: "If you do not see your payment success within 24 hours, please contact us!",
      PaymentCanceledHeading: "Payment Canceled",
      PaymentCancelledText: "The payment was canceled. Your account was not billed.",
      PaymentCanceledFooter: "If you want to extend your campaign, please try again.",
      InvoiceMessage: "We will provide an invoice shortly, which will be sent by email. The invoice can also be found in your list of invoices."
    },
    SubscriptionStates: {
      Created: "Created",
      Running: "Running",
      PauseRequested: "Pause Requested",
      Paused: "Paused",
      ResumeRequested: "Resume Requested",
      StopRequested: "Stop Requested",
      Finished: "Finished"
    },
    Statistics: {
      Text: 'Statistics',
      TitleData: "Campaign Statistics Data",
      Date: "Date",
      ImpressionsVsClicksVsConversions: "Impressions / Clicks / Conversions",
      Performance: "Performance",
      Costs: "Costs",
      Impressions: "Impressions",
      Clicks: "Clicks",
      UniqueClicks: "Unique Clicks",
      Ctr: "Ctr",
      Cpm: "Cpm",
      Cpc: "Cpc",
      ConvPc: "Conv. Pc",
      ConvPv: "Conv. Pv",
      ConvTotal: "Conv. Total",
      Dimension: "Group By",
      SecondaryDimension: "Details By"
    },
    Strategy:
    {
      SubscriptionState: "State",
      Latitude: "Lat",
      Longitude: "Lng",
      Radius: "Radius",
      PostalCode: "Postal Code",
      Custom1: "Custom1",
      Custom2: "Custom2",
      Custom3: "Custom3",
      Custom4: "Custom4",
      Custom5: "Custom5",
      Custom6: "Custom6",
      Custom7: "Custom7",
      Custom8: "Custom8",
      Custom9: "Custom9",
      Address1: "Address 1",
      Address2: "Address 2",
      UrlTag: "Url",
      DailyBudget: "Daily Budget",
      Name: "Name",
      Title2: "Retailer",
      Title3: "Job",
      Title4: "Product",
      Sync2: "Synchronize retailers",
      Sync3: "Synchronize jobs",
      Sync4: "Synchronize products",
      Synced2: "This retailers of this campaign haven been synchronised",
      Synced3: "This jobs of this campaign haven been synchronised",
      Synced4: "This retailers of this campaign haven been synchronised"
    },
    StrategyTypeList:
    {
      NoStrategies: "No Strategies",
      Retailers: "Retailers",
      Jobs: "Jobs",
      Products: "Products",
      Articles: "Articles"
    },
    LanguageList: {
      English: 'English',
      Dutch: 'Nederlands',
      German: "Deutsch"
    },
    RoleList: {
      Administrator: "Administrator",
      User: "User",
      Retailer: "Retailer"
    },
    ReportPeriodList: {
      None: "None",
      Daily: "Daily",
      Weekly: "Weekly",
      Monthly: "Monthly"
    },
    ImageTypeList: {
      Logo: "Logo",
      Background: "Background",
    },
    Voucher: {
      List: "Voucher Codes",
      Code: "Voucher Code",
      Edit: "Edit Voucher",
      New: "New Voucher",
      Description: "Description",
      ValidFrom: "Valid from",
      ValidUntil: "Valid until",
      Value: "Value",
      MinimumSpentAmount: "Minimum spent amount",
      IsOneOff: "One Off?",
      SpentAmount: "Spent Amount"
    },
    VoucherUsage: {
      DisplayName: "The following retailers have uses this voucher code:",
      RetailerName: "Name",
      RetailerAddress1: "Address 1",
      RetailerAddress2: "Address 2",
      CampaignName: "Campaign",
      DateSpent: "Date Spent",
      InvoiceNumber: "Invoice Number",
      SpentAmount: "Amount Spent"
    },
  },
  nl: {
    English: 'English',
    Dutch: 'Nederlands',
    German: 'Deutsch',
    Admin: "Admin",
    All: "(Alle)",
    None: "(Geen)",
    Unknown: "Onbekend",
    Manage: "Beheer",
    Authentication: 'Authenticatie',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Diversen',
    ComingSoon: 'Coming Soon',
    Error: 'Fout',
    IsDeleted: "Verwijderd?",
    Success: "Success",
    RecordAdded: "Record is toegevoegd",
    RecordUpdated: "Record is aangepast",
    RecordDeleted: "Record is verwijderd",
    404: '404',
    500: '500',
    NotAuthorized: 'Niet geautoriseerd',
    Maintenance: 'Onderhoud',
    User: 'Gebruiker',
    New: "Nieuw",
    View: 'Details',
    Edit: 'Wijzigen',
    Delete: "Verwijderen",
    ConfirmDelete: "Verwijderen?",
    ByOrganisation: "Organisatie details",
    UserSettings: 'Voorkeuren',
    Invoice: 'Factuur',
    FAQ: 'FAQ',
    Search: 'Zoeken',
    Charts: "Grafieken",
    KnowledgeBase: 'Knowledge Base',
    Import: 'Importeren',
    Export: 'Exporteren',
    ExportSelected: 'Export geselecteerd',
    Other: 'Overige',
    Support: 'Support',
    Documentation: 'Documentatie',
    RaiseSupport: 'Support',
    UpdatedMessage: '{entity} is bijgewerkt',
    AboutToDeleteMessage: 'Wil je {entity} {name} verwijderen?',
    DeletedMessage: '{entity} {name} is verwijderd',
    DeletedTitle: '{entity} verwijderd',
    Cancel: "Annuleren",
    Ok: "Ok",
    Save: "Opslaan",
    Reset: "Ongedaan maken",
    Id: "Id",
    Name: "Naam",
    Preferences: "Voorkeuren",
    ChangeImage: "Afbeelding aanpassen",
    Language: {
      English: "Engels",
      Dutch: "Nederlands",
      German: "Duits",
      French: "Frans",
      Spanish: "Spaans"
    },
    Country: {
      gb: "Verenigd Koninkrijk",
      nl: "Nederland",
      de: "Duitsland",
      us: "Verenigde Statem",
      be: "Belgi\u00EB",
      fr: "Frankrijk"
    },
    Topic: {
      WORLD: "Wereld",
      NATION: "Land",
      BUSINESS: "Zakelijk",
      TECHNOLOGY: "Technologie",
      ENTERTAINMENT: "Amusement",
      SCIENCE: "Wetenschap",
      SPORTS: "Sport",
      HEALTH: "Gezondheid",
    },
    Products: {
      DailyBudget: "Dagbudget",
      Banners: "Opstellen Banners",
      Discount: "Korting",
      Setup: "Inrichtingskosten",
      Other: "Overig"
    },
    Weekdays: {
      Monday: "Maandag",
      Tuesday: "Dinsdag",
      Wednesday: "Woensdag",
      Thursday: "Donderdag",
      Friday: "Vrijdag",
      Saturday: "Zaterdag",
      Sunday: "Zondag"
    },
    Dashboard: {
      Title: "Dashboard",
      Analytics: 'Analyse',
      AnalyticsData: "Data",
      NoActiveCampaign: "Er is op dit moment geen activeve campagne. Wanneer je eerste campagne gestart is, zul je hier de statistieken kunnen zien."
    },
    Advertiser: {
      Title: "Adverteerder",
      Name: "Naam",
      OrganisationName: "Organisatie",
      AdvertiserId: "AdvertiserId",
      AdvertiserIdDetail: "AdvertiserId (bij de provider)",
      List: "Adverteerders",
      View: "Adverteerder Details",
      Edit: "Adverteerder wijzigen",
      Agency: "Agentschap",
      IsPremium: "Premium?",
      IsPremiumDetail: "Is premium adverteerder?",
      AgencyName: "Agentschap",
      ProviderName: "Provider",
      OwnerName: "Eigenaar",
      OwnerEmail: "E-mailadres eigenaar",
      NameRequired: "Naam is verplicht",
      OrganisationRequired: "Organisatie is verplicht",
      AgencyRequired: "Agentschap is verplicht",
      OwnerRequired: "Eigenaar is verplicht",
      ProviderAdvertiserRequired: "AdvertiserId (bij de provider) is verplicht",
      Campaigns: "Campagnes",
      AddCampaigns: "Campagnes toevoegen",
      New: "Nieuwe adverteerder",
      Added: "De adverteerder is toegevoegd",
      Updated: "De adverteerder is aangepast",
      DeleteQuestion: "Wil je adverteerder \"{name}\" verwijderen?",
      Deleted: "De adverteerder is verwijderd"
    },
    Analytics: {
      ImpressionsComparison: "Vergelijking impressies",
      Performance: "Voortgang",
      Clicks: "Clicks",
      Conversions: "Conversies",
      Impressions: "Impressies",
      AmountSpent: "Besteed",
      CostsPerClick: "Kosten per click",
      ThisMonth: "Huidige maand",
      LastMonth: "Vorige maand"
    },
    ArticleList: {
      Title: "Artikelverzameling",
      Name: "Naam",
      Reference: "Referentie",
      List: "Artikelverzamelingen",
      View: "Artikelverzameling Details",
      Edit: "Wijzigen",
      New: "Nieuwe artikelverzameling",
      Articles: "Artikelen",
      Created: "De artikelverzameling is aangemaakt",
      Updated: "De artikelverzameling is aangepast",
      DeleteQuestion: "Wil je artikelverzameling \"{name}\" verwijderen?",
      DeletedTitle: "Artikelverzameling is verwijderd",
      DeletedMessage: "De geselecteerde artikelverzameling is verwijderd",
      ActiveArticles: "Actieve artikelen",
      InactiveArticles: "Inactieve artikelen",
      Settings: "Instellingen",
      Fields: "Velden",
      FeedUrl: "RssFeed Url",
      SyncFeed: "Syncen met RssFeed",
      SyncQuestion: "Wil je artikelverzameling \"{name}\" synchroniseren met de RssFeed?",
      Synchronize: "Synschroniseren",
      Synchronized: "De artikelverzameling is gesynchroniseerd",
      ConfirmSync: "Synchroniseren?"
    },
    Article: {
      New: "Nieuw artikel",
      Edit: "Wijzigen",
      Deactivate: "Deactiveren",
      DeactivateQuestion: "Wil je het artikel \"{title}\" deactiveren? De wijziging is direct zichtbaar",
      Deactivated: "Artikel \"{title}\" is gedeactiveerd",
      Activate: "Activeren",
      ActivateQuestion: "Wil je het artikel \"{title}\" activeren? De wijziging is direct zichtbaar",
      Activated: "Artikel \"{title}\" is nu actief",
      TitleNew: "Nieuw artilel",
      TitleEdit: "Artikel wijzigen",
      Title: "Titel",
      TitleRequired: "Titel is verplicht",
      Summary: "Samenvatting",
      Kind: "Soort",
      CallToAction: "Call to action",
      Url: "Url",
      UrlRequired: "Url is verplicht",
      UploadImageText1: "Sleep de afbeelding hierheen",
      UploadImageText2: "…of klik hier",
      Image: "Afbeelding",
      ImageUploadRequired: "Upload eerst een afbeelding",
      ArticleSaved: "Artikel is aangepast"
    },
    Field: {
      New: "Nieuw veld",
      Edit: "Veld wijzigen",
      Name: "Naam",
      NameRequired: "Naam is verplicht",
      FieldType: "Veldtype",
      Label: "Label",
      LabelRequired: "Label is verplicht",
      Updated: "Het veld is aangepast",
      Added: "Het veld is toegevoegd",
      Deleted: "Het veld is verwijderd",
      DeleteQuestion: "Wil je het veld \"{name}\" verwijderen?"

    },
    FieldTypes: {
      Text: "Tekst",
      Html: "Html",
      Boolean: "Ja/Nee",
      Number: "Nummer",
      DateTime: "Datum/tijd",
      Image: "Afbeelding",
      ImageList: "Afbeelding - verzameling"
    },
    NewsArticleList: {
      Title: "Nieuwsfeed",
      Name: "Naam",
      NameRequired: "Naam is verplicht",
      Reference: "Referentie",
      List: "Nieuwsfeeds",
      View: "Nieuwsfeed Details",
      Edit: "Wijzigen",
      New: "Nieuwe nieuwsfeed",
      Preview: "Preview",
      Created: "De nieuwsfeed is aangemaakt",
      Updated: "De nieuwsfeed is aangepast",
      DeleteQuestion: "Wil je nieuwsfeed \"{name}\" verwijderen?",
      DeletedTitle: "Nieuwsfeed is verwijderd",
      DeletedMessage: "De geselecteerde nieuwsfeed is verwijderd",
      Settings: "Instellingen",
      Kind: "Soort",
      KindRequired: "Soort is verplicht",
      Keywords: "Zoektermen",
      Country: "Land",
      CountryRequired: "Land is verplicht",
      Language: "Taal",
      LanguageRequired: "Taal is verplicht",
      Topic: "Onderwerp",
      TpoicRequired: "Onderwerp is verplicht"

    },
    Keyword: {
      List: "Zoektermen",
      New: "Nieuwe zoekterm",
      Edit: "Zoekterm wijzigen",
      Value: "Zoekterm",
      ValueRequired: "Zoekterm is verplicht",
      Kind: "Soort",
      ExactMatch: "Exact Match?",
      Deleted: "De zoekterm is verwijderd",
      DeleteQuestion: "Wil je zoekterm \"{keyword}\" verwijderen?"
    },
    NewsfeedKind: {
      Headlines: "Artikelkoppen",
      HeadlinesByTopic: "Onderwerp",
      HeadlinesByLocation: "Lokatie",
      Keywords: "Zoektermen"
    },
    KeywordKind: {
      Include: "Bevat",
      Exclude: "Bevat niet"
    },
    Banner: {
      Title: "Banners"
    },
    Organisation: {
      Title: "Organisatie",
      Name: "Naam",
      LogoUrl: "Logo Url",
      List: "Organisaties",
      View: "Organisatie Details",
      Edit: "Organisatie wijzigen",
      New: "Nieuwe organisatie",
      Users: "Gebruikers bij organisatie",
      AddUsers: "Gebruikers koppelen",
      InviteUser: "Gebruiker uitnodigen",
      Choose: "Kies een organisatie",
      ButtonChoose: "Kies",
      Updated: "De organisatie aangepast",
      Added: "De organisatie is toegevoegd",
      Deleted: "De organisatie is verwijderd",
      DeleteQuestion: "Wil je de organisatie \"{name}\" verwijderen?",
      TradeName: "Handelsnaam",
      Street: "Straat",
      HouseNumber: "Huisnummer",
      HouseNumberAddition: "Huisnr. toevoeging",
      City: "Woonplaats",
      PostalCode: "Postcode",
      Country: "Land",
      StreetRequired: "Straat is verplicht",
      HouseNumberInvalid: "Huisnummer is verplicht",
      HouseNumberRequired: "Huisnummer moet tussen de 1 en 999999 liggen",
      CityRequired: "Woonplaats is verplicht",
      PostalCodeRequired: "Postcode is verplicht",
      CountryRequired: "Land is verplicht",
      VatNumber: "BTW-nummer",
      VatExemption: "BTW verlegd?",
    },
    OrganisationUser: {
      List: "Gebruikers",
      Title: "Gebruiker",
      Name: "Naam",
      Email: "E-mailadres",
      Role: "Rol",
      Language: "Taal",
      Company: "Bedrijf",
      FirstName: "Voornaam",
      LastName: "Achternaam",
      PhoneNumber: "Telefoon",
      SendInvitation: "Uitnodiging verzenden",
      ExcelReport: "Dagelijks Excel Rapport?",
      ReportingPeriod: "PDF Voortgangsrapportage",
      ReportingDays: "PDF Rapport aantal dagen",
      AddUsersToOrganisation: "Gebruikers aan organisatie koppelen",
      AddUsers: "Gebruikers koppelen",
      EmailRequired: "E-mailadres is verplicht",
      EmailInvalid: "E-mail adres is ongeldig",
      EmailAlreadyRegistered: "Er bestaat al een gebruiker met dit e-mailadres",
      FirstNameRequired: "Voornaam is verplicht",
      LastNameRequired: "Achternaam is verplicht",
      IsMainContact: "Algemeen contact?",
      IsFinancialContact: "Financieel contact?",
    },
    Campaign: {
      Title: "Campagne",
      Name: "Naam",
      NameRequired: "Naam is verplicht",
      NewsFeeds: "Nieuwsfeeds voor deze campagne",
      List: "Campagnes",
      View: "Campagne Details",
      Edit: "Campagne wijzigen",
      NewCampaign: "Nieuwe Campagne",
      Strategies2: "Retailers",
      Strategies3: "Jobs",
      Strategies4: "Producten",
      Strategies5: "Artikelen",
      Images: "Afbeeldingen",
      IdStrategyType: "Campagnetype",
      StrategyType: "Campagnetype",
      StrategyTypeRequired: "Campagnetype is verplicht",
      JobFeed: "Jobfeed",
      ArticleList: "Artikellijst",
      IsPremium: "Premium?",
      IsPremiumDetail: "Is dit een premium campagne?",
      IsActive: "Actief?",
      IsActiveDetail: "Is deze campagne actief?",
      HasStrategies: "Heeft strategie\u00EBn?",
      HasStrategiesDetail: "Heeft de campagne strategie\u00EBn?",
      Subscriptions: "Abonnementen",
      HasSubscriptions: "Abonnementen?",
      HasSubscriptionsDetail: "Heeft de campagne abonnementen?",
      CampaignId: "Campagne Id",
      UpdatedTitle: "Campagne bijgewerkt",
      UpdatedMessage: "De wijzigingen aan de campagne zijn opgeslagen",
      RetailerCanBuySubscription: "Kan een retail een abonnement kopen?",
      AdvertiserCanAddSubscription: "Kan de adverteerder een abonnement (op rekening) toevoegen?",
      StartDate: "Startdatum",
      EndDate: "Einddatum",
      Budget: "Budget",
      AmountSpent: "- Waarvan besteed",
      AmountPlanned: "- Waarvan ingepland",
      AmountPlannable: "- Nog in te plannen",
      BudgetLines: "Budgetregels",
      LinkOrderLines: "Orderregels koppelen",
      AddOrderLines: "Koppelen",
      DeleteBudgetLineQuestion: "Wil je deze budgetregel verwijderen?",
      PlanningPerDay: "Planning",
      SpentPerDay: "Besteed",
      BudgetPerDay: "Budgetten per dag",
      AddBudgetDays: "Dagbudgetten toevoegen"
    },
    CampaignDailyBudget: {
      BudgetDate: "Budgetdatum",
      Budget: "Budget",
      Spent: "Besteed",
      NumberOfDays: "Aantal dagen",
      StartDate: "Startdatum",
      NumberOfDaysRequired: "Aantal dagen is verplicht",
      NumberOfDaysRange: "Moet tussen de 1 en 1000 liggen",
      StartDateRequired: "Startdatum is verplicht",
      BudgetRequired: "Budget is verplicht",
      BudgetRange: "Moet tussen de 10 en 100.000 liggen",
      Weekdays: "Kies de dagen van de week",
      Description: "Omschrijving",
      AddBudgetDays: "Dagbudgetten toevoegen",
      AmountPlannable: "Nog in te plannnen",
      BudgetToAdd: "Totaal toe te voegen",
      BudgetRemainder: "Overgebleven budget",
      BudgetDeficit: "Budget tekort",
      BudgetBalanceNegative: "Er is onvoldoende saldo om deze dagbudgetten toe te voegen",
      BudgetAdded: "De dagbudgetten zijn toegevoegd",
      WeekdayRequired: "Kies minimaal 1 dag van de week",
      Difference: "Saldo",
      DayOfWeek: "Dag"
    },
    CampaignImage: {
      List: "Campagne afbeeldingen",
      Type: "Afbeelding type",
      Categories: "Gebruik voor deze categorie\u00EBn?",
      ImageUploadRequired: "Upload eerst een afbeelding",
      SubmitAdd: "Opslaan",
      TitleAdd: "Afbeelding aan een campagne toevoegem",
      ImageAdded: "De afbeelding is toegevoegd aan de campagne",
      UploadImageText1: "Sleep de afbeelding hierheen",
      UploadImageText2: "…of klik hier",
      Image: "Afbeelding",
      AddImage: "Afbeelding toevoegen",
      Delete: "Afbeelding verwijderen",
      DeleteQuestion: "Wil je deze afbeelding verwijderen?",
      ImageDeleted: "Afbeelding is verwijderd"
    },
    JobFeed: {
      Title: "Jobfeed",
      Name: "Naam",
      NameRequired: "Naam is verplicht",
      List: "Jobfeeds",
      View: "Jobfeed Details",
      Edit: "Wijzigen Jobfeed",
      New: "Nieuwe Jobfeed",
      IdJobFeedType: "Jobfeedtype",
      JobFeedTypeRequired: "Jobfeedtype is verplicht",
      Jobs: "Jobs",
      FeedUrl: "Jobfeed url",
      FeedUrlRequired: "Jobfeed url is verplicht",
      Added: "De jobfeed is toegevoegd",
      Updated: "De jobfeed is aangepast",
      Deleted: "De jobfeed is verwijderd",
      DeleteQuestion: "Wil je jobfeed \"{name}\" verwijderen?"
    },
    Login: {
      Title: "Inloggen bij UpStreamAds",
      Login: 'Inloggen',
      LoginFailed: "E-mailadres of wachtwoord onjuist",
      Welcome: "Log in met je e-mailadres en wachtwoord",
      Register: 'Registreren',
      ForgotPassword: 'Wachtwoord vergeten?',
      Email: "E-mailadres",
      EmailPlaceholder: "E-mailadres",
      Password: "Wachtwoord",
      PasswordPlaceholder: "Wachtwoord",
      AlreadyLoggedIn: "Je bent al ingelogd"
    },
    ForgotPassword: {
      RecoverYourPasswordTitle: "Wachtwoord vergeten?",
      CheckYourEmailTitle: "Controleer je e-mail",
      PleaseEnterEmail: "Vul je e-mailadres en we sturen je een tijdelijke code om mee in te loggen",
      PleaseCheckInbox: "We hebben je een e-mail gestuurd met daarin een tijdelijke code. Vul deze code hieronder in",
      RecoverPassword: "Wachtwoord herstellen",
      BackToLogin: "Terug naar inloggen"
    },
    JobItem: {
      ReferenceNumber: "Referentie",
      Title: "Titel",
      Date: "Datum aanmaak",
      Url: "Url",
      Categories: "Categorie\u00EBn"
    },
    Retailer: {
      Name: "Naam",
      Address1: "Adres1",
      Address2: "Adres2",
      Title: "Retailer",
      List: "Retailers",
      Users: "De volgende gebruikers hebben toegang tot de gegevens van deze retailer:"
    },
    RetailerUser: {
      List: "Gebruikers",
      Title: "User",
      Edit: "Gebruiker wijzigen",
      Name: "Naam",
      Email: "E-mailadres",
      Role: "Rol",
      IsOwner: "Eigenaar?",
      Language: "Taal",
      Company: "Bedrijfsnaam",
      FirstName: "Voornaam",
      LastName: "Achternaam",
      PhoneNumber: "Telefoon",
      InviteUser: "Gebruiker uitnodigen",
      SendInvitation: "Uitnodiging versturen",
      AddUsersToRetailer: "Gebruikers koppelen",
      AddUsers: "Gebruikers koppelen",
      EmailRequired: "E-mailadres is verplciht",
      EmailInvalid: "E-mailadres is onjuist",
      EmailAlreadyRegistered: "Er bestaat al een gebruiker met dit e-mailadres",
      FirstNameRequired: "Voornaam is verplicht",
      LastNameRequired: "Achternaam is verplicht",
      EntityAlreadyExistsException: "Er is al een gebruiker met dit e-mailadres gekoppeld"
    },
    Subscription: {
      Description: "Omschrijving",
      NoSubscriptionsActive: "Er is (nog) geen actief abonnement",
      DailyBudgetFor: "Dagbudget voor",
      Create: "Abonnement aanmaken",
      Buy: "Abonnement kopen",
      StartDate: "Startdatum",
      DailyBudget: "Dagbudget",
      TotalDays: "Aantal dagen",
      DaysSpent: "Dagen gedraaid",
      DaysPaused: "Dagen gepauzeerd",
      SubscriptionId: "ID",
      Actions: "Acties",
      ActionPause: "Abonnement pauzeren",
      ActionResume: "Abonnement herstarten",
      ActionStop: "Abonnement be\u00EBindigen",
      Details: "Details",
      State: "Status",
      Created: "Orderdatum",
      EndDate: "Einddatum",
      NoSubscriptionsHeading: "Nog geen abonnementen",
      NoSubscriptionsText: "Er zijn geen abonnementen voor deze campagne",
      NoSubscriptionsInfo: "Vul je tegoed aan bij deze campagne als je een abonnement wilt nemen",
      BuySubscription: "Tegoed aanvullen",
      Progress: "Voortgang",
      TotalBudget: "Totaal Budget",
      RemaningBudget: "Budget Beschikbaar",
      ActionPauseQuestion: "Wil je dit abonnement pauzeren? Het pauzeren zal ingaan vanaf morgen.",
      ActionResumeQuestion: "Wil je dit abonnement herstarten? Het abonnement zal vanaf morgen weer draaien.",
      ActionStopQuestion: "Wil je dit abonnement be\u00EBindigen? Het abonnement zal vanaf morgen worden be\u00EBindigd",
      PauseRequested: "Pauzeren is aangevraagd",
      ResumeRequested: "Herstart is aangevraagd",
      StopRequested: "Be\u00EBindigen is aangevraagd"
    },
    BuySubscription: {
      Title: "Tegoed kopen",
      SelectDateRange: "Start- en einddatum",
      DailyBudget: "Dagbuget",
      RunTime: "Looptijd (dagen)",
      TotalBudget: "Totaal Budget",
      TotalBudgetExplanation: "{days} dagen x {euro} per dag",
      TotalVat: "B.T.W. 21%",
      PaymentTotal: "Totaal",
      Days: "Dagen",
      Buy: "Kopen",
      OrderHasBeenPlacedAndPaid: "Je order is geplaatst en betaald",
      MinBudgetWarning: "Waarschuwing: een dagbudget van minder dan 3 euro is minder effectief!",
      OrderAndPay: "Bestellen en betalen",
      ExchangeVoucher: "Vouchercode inwisselen",
      VoucherCode: "Vouchercode",
      ApplyVoucher: "Toepassen",
      VoucherAlreadyUsed: "De voucher is al gebruikt",
      VoucherExpired: "De voucher is niet meer geldig",
      VoucherNotFound: "Geen voucher met deze code gevonden",
      VoucherNotYetValid: "Deze voucher is nog niet geldig",
      RemoveVoucherCode: "Verwijder vouchercode {code}",
      ReductionAmount: "Korting",
      ReductionExplanation1: "Maximaal \u20ac {voucherValue} korting",
      ReductionExplanation2: "\u20ac {voucherValue} korting bij besteding van \u20ac {voucherMinimumSpentAmount} of meer"
    },
    Order: {
      List: "Orders",
      Order: "Order",
      OrderNumber: "Ordernummer",
      Edit: "Order wijzigen",
      New: "Nieuwe order",
      View: "Order Details",
      OrderDate: "Orderdatum",
      ProposalDate: "Offertedatum",
      ProposalValidUntil: "Offerte geldig t/m",
      TotalBudgetExplanation: "{days} dagen x {euro} per dag",
      LineExplanation: "{quantity} x {pricePerUnit}",
      OrderLines: "Orderregels",
      General: "Algemeen",
      Notes: "Uitgebreide omschrijving",
      StartDate: "Startdatum",
      EndDate: "Einddatum",
      Details: "Details",
      Amount: "Totaal ex. BTW",
      AmountVAT: "BTW",
      OrderTotal: "Totaal incl. BTW",
      DownloadInvoice: "Factuur downloaden",
      Description: "Omschrijving",
      DescriptionRequired: "Omschrijving is verplicht",
      CustomerReference: "Uw referentie",
      CreateInvoice: "Factuur aanmaken",
      SendInvoice: "Factuur e-mailen",
      DeleteQuestion: "Wil je order \"{name}\" verwijderen?",
      State: "Status",
      Added: "De order is aangemaakt",
      Updated: "De order is bijgewerkt",
      Deleted: "De order is verwijderd",
      EmailProposal: "Offerte e-mailen",
      EmailOrder: "Order e-mailen",
      EmailSendButton: "Versturen",
      EmailUser: "Stuur de e-mail naar",
      CreateInvoiceButton: "Aanmaken",
      InvoiceDate: "Factuurdatum"
    },
    OrderLine: {
      IdProduct: "Product",
      Description: "Omschrijving",
      PricePerUnit: "Prijs / stuk",
      Quantity: "Aantal",
      IdProductRequired: "Product is verplicht",
      DescriptionRequired: "Omschrijving is verplicht",
      Total: "Totaal",
      New: "Nieuwe regel",
      StartDate: "Startdatum",
      EndDate: "Einddatum",
      QuantityRequired: "Aantal is verplicht",
      QuantityRange: "Aantal moet tussen de 1 en 1000 liggen",
      PricePerUnitRequired: "Prijs / stuk is verplicht",
      PricePerUnitRange: "Prijs / stuk moet tussen de -100.000 en 100.000 liggen"
    },
    OrderState: {
      Created: "Aangemaakt",
      PaymentInProgress: "Betaling bezig",
      Confirmed: "Bevestigd",
      PaymentCanceled: "Betaling geannuleerd",
      Canceled: "Geannuleerd",
      Proposal: "Offerte",
      Archived: "Gearchiveerd"
    },
    SubscriptionStates: {
      Created: "Aangemaakt",
      Running: "Actief",
      PauseRequested: "Pauzeren aangevraagd",
      Paused: "Gepauzeerd",
      ResumeRequested: "Herstart aangevraagd",
      StopRequested: "Be\u00EBindiging aangevraagd",
      Finished: "Be\u00EBindigd"
    },
    PaymentFinished: {
      Title: "Betaalstatus",
      PaymentSuccessHeading: "Betaling is gelukt",
      PaymentSuccessText: "Dankjewel voor je bestelling",
      PaymentSuccessFooter: "We hebben het ontvangen bedrag aan je saldo toegevoegd",
      PaymentPendingHeading: "Betaling is not niet afgerond",
      PaymentPendingText: "De betaling is nog niet afgerond",
      PaymentPendingFooter: "Als je niet binnen 24 uur ziet dat je betaling door ons is ontvangen, neem dan contact met ons op!",
      PaymentCanceledHeading: "Betaling geannuleerd",
      PaymentCancelledText: "De betaling is geannuleerd",
      PaymentCanceledFooter: "Als je budget wilt toevoegen aan je campagne, probeer het dan opniew",
      InvoiceMessage: "We sturen direct een e-mail met de factuur. Je kunt de factuur ook vinden in je order overzicht"
    },
    Statistics: {
      Text: 'Statistieken',
      TitleData: "Campagne Statistieken: data",
      Date: "Datum",
      ImpressionsVsClicksVsConversions: "Impressies / Clicks / Conversies",
      Performance: "Performance",
      Day: "Date",
      Costs: "Kosten",
      Impressions: "Impressies",
      Clicks: "Clicks",
      UniqueClicks: "Unieke Clicks",
      Ctr: "Ctr",
      Cpm: "Cpm",
      Cpc: "Cpc",
      ConvPc: "Conv. Pc",
      ConvPv: "Conv. Pv",
      ConvTotal: "Conv. Total",
      Dimension: "Group By",
      SecondaryDimension: "Details By"
    },
    Strategy:
    {
      SubscriptionState: "Status",
      Latitude: "Lat",
      Longitude: "Lng",
      Radius: "Radius",
      PostalCode: "Postcode",
      Custom1: "Custom1",
      Custom2: "Custom2",
      Custom3: "Custom3",
      Custom4: "Custom4",
      Custom5: "Custom5",
      Custom6: "Custom6",
      Custom7: "Custom7",
      Custom8: "Custom8",
      Custom9: "Custom9",
      Address1: "Adres 1",
      Address2: "Adres 2",
      UrlTag: "Url",
      DailyBudget: "Dagbudget",
      Name: "Naam",
      Title2: "Retailer",
      Title3: "Job",
      Title4: "Product",
      Sync2: "Retailers syncen",
      Sync3: "Jobs syncen",
      Sync4: "Producten syncen",
      Synced2: "De retailers zijn gesynchroniseerd",
      Synced3: "De jobs zijn gesynchroniseerd",
      Synced4: "De producten zijn gesynchroniseerd",
    },
    RoleList: {
      Administrator: "Beheerder",
      User: "Gebruiker",
      Retailer: "Retailer"
    },
    ReportPeriodList: {
      None: "Geen",
      Daily: "Dagelijks",
      Weekly: "Wekelijks",
      Monthly: "Maandelijks"
    },
    StrategyTypeList: {
      NoStrategies: "Geen",
      Retailers: "Retailers",
      Jobs: "Jobs",
      Products: "Producten",
      Articles: "Artikelen"
    },
    ImageTypeList: {
      Logo: "Logo",
      Background: "Achtergrond",
    },
    Profile: {
      Title: "Profiel",
      General: "Persoonlijke gegevens",
      ChangePassword: "Wachtwoord wijzigen",
      Preferences: "Voorkeuren",
      NewPassword: "Nieuw wachtwoord",
      RepeatPassword: "Herhaal wachtwoord",
      PasswordRequired: "Vul alsjeblieft je nieuwe wachtwoord in",
      PasswordMinLength: "Een wachtwoord moet minimaal 5 tekens bevatten (liefst meer)",
      PasswordsMustMatch: "De ingevulde wachtwoorden moeten gelijks zijn ",
      PasswordChanged: "Je wachtwoord is gewijzigd",
      Company: "Bedrijfsnaam",
      DisplayName: "Gebruikersnaam",
      ProfileUpdated: "Je gegevens zijn bijgewerkt",
      FirstName: "Voornaam",
      FirstNameRequired: "Voornaam is verplicht",
      LastName: "Achternaam",
      LastNameRequired: "Achternaam is verplicht",
      Street: "Straat",
      HouseNumber: "Huisnummer",
      HouseNumberAddition: "Huisnr. toevoeging",
      City: "Woonplaats",
      PostalCode: "Postcode",
      Country: "Land",
      Language: "Taal",
      StreetRequired: "Straat is verplicht",
      HouseNumberRequired: "Huisnummer moet tussen de 1 en 999999 liggen",
      CityRequired: "Woonplaats is verplicht",
      PostalCodeRequired: "Postcode is verplicht",
      CountryRequired: "Land is verplicht",
      LanguageRequired: "Taal is verplicht",
      VatNumber: "BTW-nummer",
      VatExemption: "BTW verlegd?"
    },
    Voucher: {
      List: "Vouchers",
      Code: "Vouchercode",
      Edit: "Voucher wijzigen",
      New: "Nieuwe voucher",
      Description: "Omschrijving",
      ValidFrom: "Geldig vanaf",
      ValidUntil: "Geldig t/m",
      Value: "Waarde",
      MinimumSpentAmount: "Bij besteding van",
      IsOneOff: "Eenmalig?",
      SpentAmount: "Besteed"
    },
    VoucherUsage: {
      DisplayName: "De volgende retailers hebben deze vouchercode gebruikt:",
      RetailerName: "Naam",
      RetailerAddress1: "Adres 1",
      RetailerAddress2: "Adres 2",
      CampaignName: "Campagne",
      DateSpent: "Besteed op",
      InvoiceNumber: "Factuurnummmer",
      SpentAmount: "Besteed"
    },
  },
}
